import { IResponse } from "models";

export enum ActionType {
  FORGOT_PASSWORD = "action/FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS = "action/FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_ERROR = "action/FORGOT_PASSWORD_ERROR",
  FORGOT_PASSWORD_RESET = "action/FORGOT_PASSWORD_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ForgotPasswordData {
  email: string | null;
}

export interface ForgotPasswordResponse extends IResponse {
  message: string;
}
